import {useIntl} from 'react-intl';
import {Check} from 'lucide-react';
import {teamCallMessages as m} from './teamMessages';

export const SelectCheckbox = ({name, checked, onToggle}: {name: string; checked: boolean; onToggle: () => void}) => {
    const intl = useIntl();
    return (
        <button
            type="button"
            role="checkbox"
            aria-checked={checked}
            aria-label={intl.formatMessage(m.selectPerson, {name})}
            data-testid="team-select"
            onClick={onToggle}
            className={`inline-flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-md border border-solid ${checked ? 'border-brand bg-brand text-white' : 'border-zinc-300 bg-surface'}`}
        >
            {checked && <Check size={14} className="!text-white" aria-hidden="true"/>}
        </button>
    );
};
